<template>
  <div class="mt-10">
    <LoadingAnimation full-page v-if="loading" />
    <PdfGen
      landscape
      invisible
      page-size="A3"
      :header-data="pdfHeader"
      :content-data="pdfData"
      ref="pdf"
      :key="'pdf_' + pdfKey"
      :name="
        localStorage.translations.pages.planning.pages['obem-zakazov'] +
        ' ' +
        new Date().getDate() +
        '.' +
        (new Date().getMonth() + 1) +
        '.' +
        new Date().getFullYear() +
        '.pdf'
      "
    />
    <BaseButton
      @click="onPrintPdf()"
      default_icon="button-create_pdf"
      round
      icon_only
    />
  </div>
</template>

<script>
import PdfGen from "components/pdf/pdfGen";
import {mapGetters, mapMutations} from "vuex";
import LoadingAnimation from "components/LoadingAnimation";

export default {
  name: "PlanningTableWorkPDF",
  components: {LoadingAnimation, PdfGen},
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    formatDate: {
      type: String,
      default: ''
    },
    total: {
      type: [Number, String],
      default: ''
    }
  },
  data: () => ({
    pdfData: null,
    pdfKey: 0,
    pdfSave: false,
    loading: false,
  }),
  computed: {
    ...mapGetters(['companiesConfig']),
    t() {
      return this.localStorage.translations.pages['planning_orders'].table
    },
    pdfHeader() {
      return {
        style: 'header',
        columns: [
          {
            table: {
              widths: ['auto', '*', 150],
              body: [
                [
                  [
                    {
                      image: 'logo',
                      fit: [33, 33],
                      margin: [11, 10, 10, 10],
                    },
                    {
                      text: this.companiesConfig.company_name,
                      style: 'black',
                      margin: [11, 0, 10, 5],
                    },
                    {
                      text: this.t['avtor'] + ':',
                      style: 'black',
                      margin: [11, 0, 10, 5],
                    },
                  ],
                  {
                    text: this.companiesConfig.executor,
                    style: ['black', 'primary_color'],
                    margin: [15, 67, 10, 5],
                  },
                  [
                    {
                      text:
                        this.localStorage.translations.pages.planning.pages['obem-zakazov'] +
                        ' ' +
                        new Date().getFullYear(),
                      style: 'black',
                      margin: [0, 10, 11, 5],
                      alignment: 'right',
                    },
                    {
                      text: [
                        {
                          text: this.t['data'] + ': ',
                          style: 'black',
                        },
                        {
                          text: this.formatDate,
                          style: ['black', 'primary_color'],
                        },
                      ],
                      margin: [0, 43, 11, 0],
                      alignment: 'right',
                    },
                  ],
                ],
              ],
            },
            layout: {
              hLineColor: '#d2d5d9',
              hLineWidth: function (i) {
                return i === 0 ? 0 : 0.25
              },
              vLineWidth: function (i) {
                return 0
              },
            },
          },
        ],
      }
    },
    pdfGenReady() {
      if (this.$refs.pdf) return this.$refs.pdf.documentReady
      return false
    },
  },
  watch: {
    pdfGenReady() {
      if (this.pdfGenReady && this.pdfSave) {
        this.pdfSave = false
        this.loading = false
        this.$refs.pdf.onDownload()
      }
    },
  },
  methods: {
    ...mapMutations(['setLoadingAnimationFullPage']),
    async onPrintPdf() {
      this.loading = true
      await this.getDataPDF()
    },
    
    getDataPDF() {
      this.pdfSave = false
      let temp = [
        {
          style: 'text_lh',
          margin: [0, 0, 0, 10],
          table: {
            widths: ['auto', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: [
              [
                {text: '№', style: ['black']},
                {text: this.t['proekt'], style: ['black']},
                {text: this.t['gorod'], style: ['black']},
                {text: this.t['klient'], style: ['black']},
                {text: this.t['nazvanie-raboty'], style: ['black']},
                {text: this.t['measure'], style: ['black']},
                {text: this.t['obem-rabot'], style: ['black']},
                {text: this.t['tsena'], style: ['black']},
                {text: this.t['v-itoge'], style: ['black']},
                {text: this.t['obshchiy'], style: ['black']},
              ],
            ],
          },
          layout: {
            vLineColor: '#ebebeb',
            hLineColor: '#ebebeb',
            paddingTop: function (i, node) {
              return 6
            },
            paddingBottom: function (i, node) {
              return 3
            },
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? '#f2f2f2' : null
            },
          }
        },
        {
          style: 'header_black_12',
          table: {
            widths: ['*', 'auto'],
            body: [
              [
                '',
                {text: this.t['obem-zakazov'] + ': ' + this.total + ' €'},
              ],
            ],
          },
          layout: 'noBorders',
        },
        {
          style: ['header', 'bold'],
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*', 'auto', '*'],
            body: [
              [
                [{text: this.companiesConfig.company_name}, {text: this.companiesConfig.registration_address}],
                [
                  {text: this.t['telefon'] + ': ' + this.companiesConfig.phone},
                  {text: this.companiesConfig.email},
                ],
                [
                  {
                    text: this.t['y_tunnus'] + ': ' + this.companiesConfig.company_id,
                    alignment: 'right',
                  },
                  {
                    text: this.t['mesto-propiski'] + ': ' + this.companiesConfig.registration_address_city,
                    alignment: 'right',
                  },
                ],
              ],
            ],
          },
          layout: 'noBorders',
        },
      ]
      for (let i in this.data) {
        if (this.data[i].work_types.length) {
          for (let w in this.data[i].work_types) {
            temp[0].table.body.push([
              {
                text: Number(i) + 1,
                rowSpan: Number(w) === 0 ? this.data[i].work_types.length : 1,
              },
              {
                text: this.data[i].name,
                rowSpan: Number(w) === 0 ? this.data[i].work_types.length : 1,
              },
              {
                text: this.data[i].city,
                rowSpan: Number(w) === 0 ? this.data[i].work_types.length : 1,
              },
              {
                text: this.data[i].work_client ? this.data[i].work_client.name : '',
                rowSpan: Number(w) === 0 ? this.data[i].work_types.length : 1,
              },
              {
                text: this.data[i].work_types[w].work_type.name,
                border:
                  Number(w) === 0 && Number(w) === this.data[i].work_types.length - 1
                    ? [true, true, true, true]
                    : Number(w) === 0
                      ? [true, true, true, false]
                      : Number(w) === this.data[i].work_types.length - 1
                        ? [true, false, true, true]
                        : [true, false, true, false],
              },
              {
                text: this.data[i].work_types[w].work_type.measure,
                style: ['text', 'roboto_light'],
                border:
                  Number(w) === 0 && Number(w) === this.data[i].work_types.length - 1
                    ? [true, true, true, true]
                    : Number(w) === 0
                      ? [true, true, true, false]
                      : Number(w) === this.data[i].work_types.length - 1
                        ? [true, false, true, true]
                        : [true, false, true, false],
              },
              {
                text: Number(this.data[i].work_types[w].size - this.data[i].work_types[w].done) <= 0 ? '0,00' : this.$formatCurrency(this.data[i].work_types[w].size - this.data[i].work_types[w].done),
                border:
                  Number(w) === 0 && Number(w) === this.data[i].work_types.length - 1
                    ? [true, true, true, true]
                    : Number(w) === 0
                      ? [true, true, true, false]
                      : Number(w) === this.data[i].work_types.length - 1
                        ? [true, false, true, true]
                        : [true, false, true, false],
              },
              {
                text: this.$formatCurrency(this.data[i].work_types[w].price),
                border:
                  Number(w) === 0 && Number(w) === this.data[i].work_types.length - 1
                    ? [true, true, true, true]
                    : Number(w) === 0
                      ? [true, true, true, false]
                      : Number(w) === this.data[i].work_types.length - 1
                        ? [true, false, true, true]
                        : [true, false, true, false],
              },
              {
                text: this.$formatCurrency(this.data[i].work_types[w].total),
                border:
                  Number(w) === 0 && Number(w) === this.data[i].work_types.length - 1
                    ? [true, true, true, true]
                    : Number(w) === 0
                      ? [true, true, true, false]
                      : Number(w) === this.data[i].work_types.length - 1
                        ? [true, false, true, true]
                        : [true, false, true, false],
              },
              {
                text: this.$formatCurrency(this.data[i].total),
                rowSpan: Number(w) === 0 ? this.data[i].work_types.length : 1,
              },
            ])
          }
        }
        else {
          temp[0].table.body.push([
            Number(i) + 1,
            this.data[i].name,
            this.data[i].city,
            this.data[i].work_client ? this.data[i].work_client.name : '',
            '',
            '',
            '',
            '',
            '',
            this.$formatCurrency(this.data[i].total),
          ])
        }
      }
      this.pdfData = temp
      this.pdfKey++
      this.pdfSave = true
    },
    
  }
}
</script>
